
import { CaseDetailsFlagFlagType, InputMaybe } from '../generated/resolvers'
import request from '../requesters/default'
import { setVerificationCacheInvalidation } from '../utils/caseVerificationInvalidation'
import { CaseLoader } from './case'

export const addManualFlagToCase = async (
  case_id: InputMaybe<string>,
  flag_type: InputMaybe<CaseDetailsFlagFlagType>,
): Promise<any> => {
  const payload = { case_id, flag_type }

  const response = await request.post(`/case/${case_id}/flag`, payload)

  CaseLoader.clearAll()

  // Set BE verification cache invalidation flag
  setVerificationCacheInvalidation()

  return response.data
}
